import type { WeakValidationMap } from 'react';
import type React from 'react';
import { useCallback } from 'react';
import { describe, PropTypes } from '../props-helpers/index.js';

const propTypes = {
  onFocus: PropTypes.func
    .description(
      'The function to be invoked when focusing specifically the element attached to (ignoring child focus events)',
    )
    .signature('((e: React.FocusEvent, ...args: unknown[]) => void)').isRequired,
} as WeakValidationMap<unknown>;

type OnFocusCb = (e: React.FocusEvent, ...args: unknown[]) => void;
type UseOnBlurOut = ({ onFocus }: { onFocus: OnFocusCb }) => OnFocusCb;
const useOnSpecificFocus: UseOnBlurOut = ({ onFocus }) =>
  useCallback<OnFocusCb>(
    (e, ...args) => {
      const { currentTarget, target } = e;
      if (currentTarget === target && document.activeElement === currentTarget) onFocus(e, ...args);
    },
    [onFocus],
  );
const UseOnSpecificFocusWithSchema = describe(useOnSpecificFocus);
UseOnSpecificFocusWithSchema.propTypes = propTypes;

export { useOnSpecificFocus, UseOnSpecificFocusWithSchema };
